import styled from "styled-components";
import { Flex, Icon } from "discover.medical.react-component-library";

export const StyledIcon = styled(Icon)`
  vertical-align: middle;
`;

export const CenterContentFlex = styled(Flex)`
  height: 21.875rem;
`;
